import { LockRewardStore } from "../../lock-reward-store"
import { LockRewardStoreTokenGroup } from "../../types"
import { LockRewardGroupingStrategy } from "./lock-reward-grouping-strategy"

export class ByTokenGroupingStrategy implements LockRewardGroupingStrategy<Map<string, LockRewardStoreTokenGroup>> {
  group(rewards: LockRewardStore[]): Map<string, LockRewardStoreTokenGroup> {
    const grouped = new Map<string, LockRewardStoreTokenGroup>()

    rewards.forEach((reward) => {
      const tokenAddress = reward.token.address.toString()

      if (!grouped.has(tokenAddress)) {
        grouped.set(tokenAddress, {
          tokenAddress,
          rewards: [],
          totalValueUSD: 0,
        })
      }

      const tokenGroup = grouped.get(tokenAddress)!
      tokenGroup.rewards.push(reward)
      tokenGroup.totalValueUSD += reward.valueUSD
    })

    const sorted = new Map(Array.from(grouped.entries()).sort(([, a], [, b]) => b.totalValueUSD - a.totalValueUSD))

    return sorted
  }

  strategyName(): string {
    return "by-token"
  }
}
